import React, { useState } from "react";
import axios from "axios";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import { API_URL } from "../../utils/Url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CreatePlan = () => {
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    discount: "",
    durationDays: "",
    duration: "",
    features: "",
  });
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // empty values remove
      const data = Object.fromEntries(
        Object.entries(formData).filter(([_, v]) => v !== ""),
      );

      if (data.features) {
        data.features = data.features.split(",");
      }

      await axios.post(`${API_URL}/api/admin/create/plan`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Plan created successfully");
      navigate("/get/plans");
      setFormData({
        name: "",
        price: "",
        discount: "",
        durationDays: "",
        duration: "",
        features: "",
      });
    } catch (error) {
      alert(error.response?.data?.message || "Error creating plan");
    }
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="main-content mt-5">
        <div className="card shadow">
          <div
            className="card-header align-items-center mb-3 p-2 rounded"
            style={{ backgroundColor: "#fa8ab8" }}
          >
            <h4>Create Subscription Plan</h4>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Plan Name</label>

                <select
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                >
                  <option value="">Select Plan</option>
                  <option value="Gold Plan">Gold Plan</option>
                  <option value="Silver Plan">Silver Plan</option>
                  <option value="Platinum Plan">Platinum Plan</option>
                  <option value="Till Marriage">Till Marriage</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Price</label>
                <input
                  type="number"
                  className="form-control"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Discount</label>
                <input
                  type="number"
                  className="form-control"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Duration (Optional)</label>

                <select
                  className="form-control"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                >
                  <option value="">Select Duration</option>
                  <option value="3 Months">3 Months</option>
                  <option value="6 Months">6 Months</option>
                  <option value="12 Months">12 Months</option>
                  <option value="Till U Marry">Till U Marry</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">durationDays</label>
                <input
                  type="number"
                  className="form-control"
                  name="durationDays"
                  value={formData.durationDays}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Features (comma separated)</label>
                <input
                  type="text"
                  className="form-control"
                  name="features"
                  placeholder="chat, call, view contact"
                  value={formData.features}
                  onChange={handleChange}
                />
              </div>
              <button className="btn btn-primary">Create Plan</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePlan;
